export default "__VITE_ASSET__fd983ffa__"